import { LightColors as C, Tone } from './colors';

export interface ToneColors {
  fg: string;
  soft: string;
  line: string;
}

/**
 * Resolve a tone to its {fg, soft, line} trio. Accent uses accent-ink as its
 * foreground (per theme.css .t-chip--accent), every other tone uses its own
 * color. Single source for chips, alerts and dots.
 */
export function toneColors(tone: Tone): ToneColors {
  if (tone === 'accent') {
    return { fg: C.accentInk, soft: C.accentSoft, line: C.accentLine };
  }
  const fg = C[tone];
  const soft = C[`${tone}Soft` as keyof typeof C] as string;
  const line = C[`${tone}Line` as keyof typeof C] as string;
  return { fg, soft, line };
}
